import { operatorRequiresValue } from "../Components/filters/operators";

/** UI / legacy URL field keys → metadata field_key (per module). */
const MODULE_FILTER_FIELD_ALIASES = {
  ems_leads: {
    lead_status: "lead_stage_lead_status",
    __lead_status_display: "lead_stage_lead_status",
  },
  ems_lead_activities: {
    status: "call_status",
  },
  ems_batch_class_records: {
    training_program: "training_program_id",
    batch: "organization_ems_batch_id",
    location: "ems_training_space_id",
    class_date: "start_time",
  },
  ems_batches: {
    training_program: "training_program_id",
  },
  ems_batch_students: {
    training_program: "training_program_id",
    batch: "organization_ems_batch_id",
    batch_student: "organization_ems_student_id",
    student: "organization_ems_student_id",
    status: "batch_status",
    completed_date: "completion_date",
  },
};

export function resolveMetadataFilterField(moduleId, fieldKey) {
  if (!moduleId || !fieldKey) return fieldKey;
  const aliases = MODULE_FILTER_FIELD_ALIASES[moduleId];
  return aliases?.[fieldKey] ?? fieldKey;
}

function normalizeLeadStatusFilterValue(field, value) {
  if (field !== "lead_stage_lead_status") return value;

  const toLabel = (scalar) => {
    const normalized = String(scalar).trim().toLowerCase();
    if (normalized === "1" || normalized === "true") return "Open";
    if (normalized === "0" || normalized === "false") return "Closed";
    return scalar;
  };

  if (Array.isArray(value)) {
    return value.map(toLabel);
  }

  return toLabel(value);
}

/**
 * Build FilterBuilder / metadata API filters from URL search params (filter_{field}).
 * Field aliases and enum value normalization are resolved on the backend via
 * system_filter_metadata (ui_field_key, enum_options).
 */
export function buildMetadataFiltersFromSearchParams(searchParams, moduleId = null) {
  const filters = [];
  const processedFields = new Set();

  searchParams.forEach((value, key) => {
    if (
      key.endsWith("_operator") ||
      key.endsWith("_logic") ||
      key.endsWith("_label") ||
      !key.startsWith("filter_")
    ) {
      return;
    }

    const rawField = key.replace("filter_", "");
    const field = resolveMetadataFilterField(moduleId, rawField);
    if (processedFields.has(field)) return;
    processedFields.add(field);

    const operator =
      searchParams.get(`filter_${rawField}_operator`) ||
      searchParams.get(`filter_${field}_operator`) ||
      "contains";
    const requiresValue = operatorRequiresValue(operator);

    if (!requiresValue || value) {
      let filterValue = requiresValue ? value : null;

      if (requiresValue && filterValue) {
        if (["in", "not_in"].includes(operator)) {
          const parts = filterValue.split(",").map((v) => v.trim()).filter(Boolean);
          const allNumeric = parts.every((v) => /^\d+$/.test(v));
          filterValue = allNumeric ? parts.map((v) => Number(v)) : parts;
        } else if (["equals", "not_equals"].includes(operator)) {
          if (filterValue.includes("|")) {
            const parts = filterValue.split("|").map((v) => v.trim()).filter(Boolean);
            const allNumeric = parts.every((v) => /^\d+$/.test(v));
            filterValue = allNumeric ? parts.map((v) => Number(v)) : parts;
          } else {
            filterValue = filterValue.trim();
          }
        } else if (
          ["between", "not_between", "date_between", "date_not_between"].includes(
            operator
          )
        ) {
          filterValue = filterValue.split(",").map((v) => v.trim());
        }
      }

      filterValue = normalizeLeadStatusFilterValue(field, filterValue);

      filters.push({ field, operator, value: filterValue });
    }
  });

  return filters;
}
